<template>
	<mw-dialog v-model="dialog" submitBtn cancelBtn @submit="save">
		<template v-slot:button>
			<nav-item
				@click="dialog = true"
				text="Delete"
				icon="mdi-close-circle"
			>
			</nav-item>
		</template>
		<template v-slot:dialog-body>
            Are you sure you want to delete these?
        </template>
	</mw-dialog>
</template>

<script>
import MwDialog from "@c/ui/MwDialog";
import NavItem from "@c/navigation/Item";
export default {
	name: "DeleteButton",
	props: {
		value: { type: Array }, // the id of the response,
	},
    data: () => ({
        dialog: false
    }),
	computed: {
	},
	components: {
		NavItem,
		MwDialog,
	},
    methods: {
        save(){
            this.value.forEach( v => {
                this.$store.dispatch("surveyResponses/patch", {id: v.id,  status: 'deleted' })
            })
            this.$emit("input");
        },
    }
};
</script>
